import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 7;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'donations-hub',
      title: `Donations Hub <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Record, batch, and manage all donations in one place. Donations flow through a lifecycle: entry \u2192 batching \u2192 deposit \u2192 reconciliation.',
      attachTo: { element: '[data-tour="donations-page"]', on: 'top' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'donations-add-form',
      title: `Add Donation <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Record new donations here. Enter the donor, source, fund, and amount. You can split a donation across multiple funds and track non-deductible portions.',
      attachTo: { element: '[data-tour="donations-add-form"]', on: 'bottom' },
      beforeShowPromise() {
        // Expand the collapsible entry form so the tour can highlight it
        const header = document.querySelector('[data-tour="donations-add-form"]');
        const isCollapsed = header && !header.closest('[data-tour="donations-page"]')?.querySelector('.MuiCollapse-entered');
        if (isCollapsed && header) header.click();
        return new Promise((resolve) => setTimeout(resolve, 400));
      },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'donations-register',
      title: `Donation Register <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'All donations appear here, organized by batch. Click any donation to edit or inspect it. Unbatched donations appear at the top, ready to be grouped.',
      attachTo: { element: '[data-tour="donations-register"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'donations-batches',
      title: `Batches <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Batches group donations together for deposit. A batch tracks the total amount, fees, and net deposit. <strong>Reconciled batches are locked</strong> (look for the lock icon) \u2014 they can\'t be edited because they\'ve been matched in bank reconciliation.',
      attachTo: { element: '[data-tour="donations-batches"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'donations-batch-panel',
      title: `Create a Batch <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'Select pending donations by clicking them (shift+click for ranges), then use the batch panel to set a deposit date and sweep account. <strong>Important:</strong> you can only batch donations from the same source together.',
      attachTo: { element: '[data-tour="donations-register"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'donations-import',
      title: `Import Donations <span class="t3-shepherd-step-count">${stepCounter(6)}</span>`,
      text: 'Import donations in bulk from a CSV file. T3 Books will auto-match donors and funds using fuzzy matching. You\'ll review and confirm matches before they\'re added to your books.',
      attachTo: { element: '[data-tour="donations-import-btn"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'donations-filters',
      title: `Filters <span class="t3-shepherd-step-count">${stepCounter(7)}</span>`,
      text: 'Filter donations by source, status, fund, donor, amount, or search text. Use filters to quickly find specific donations or narrow your view.',
      attachTo: { element: '[data-tour="donations-filter-btn"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'donations',
  pathPattern: '/upkeep/donations',
  getSteps,
  label: 'Donations Tour',
});
